document.addEventListener('DOMContentLoaded', function() {
    // Variáveis do Typeform
    const tfContainer = document.getElementById('tf');
    if(!tfContainer) {
        return;
    }
    const key = tfContainer.getAttribute('data-pesquisa-id');
    if(!key) {
        return;
    }
    const params = new URLSearchParams(window.location.search);
    // Função para carregar o Typeform
    function loadTypeform() {
        // Verifica se o Typeform já foi carregado para evitar duplicação
        if (tfContainer.hasAttribute('data-loaded')) return;

        // Adiciona o CSS do Typeform
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '//embed.typeform.com/next/css/widget.css';
        document.head.appendChild(link);

        // Adiciona o script do Typeform
        const script = document.createElement('script');
        script.src = '//embed.typeform.com/next/embed.js';
        script.onload = function() {
            // Marca o Typeform como carregado
            document.getElementById('tf').setAttribute('data-loaded', 'true');
            // Exibe o container do Typeform ajustando altura e visibilidade
            const tfContainer = document.getElementById('tf');
            tfContainer.style.visibility = 'visible';
            tfContainer.style.height = '550px';
            // Cria o widget do Typeform
            window.tf.createWidget(key, {
                container: tfContainer,
                inlineOnMobile: true,
                opacity: 100,
                hideHeaders: true,
                hideFooter: true,
                hidden: {
                    url: window.location.href,
                    utm_source: params.get('utm_source'),
                    utm_medium: params.get('utm_medium')
                }
            });
        };
        document.body.appendChild(script);
    }
    // Função para verificar a visibilidade do elemento na viewport
    function onScroll() {
        const tfContainer = document.getElementById('tf');
        const rect = tfContainer.getBoundingClientRect();
        // Verifica se o topo do container está na viewport
        if (rect.top <= window.innerHeight && rect.bottom > 0) {
            loadTypeform();
            window.removeEventListener('scroll', onScroll);
        }
    }
    // Adiciona o evento de rolagem
    window.addEventListener('scroll', onScroll);
});